import { ReactNode } from 'react';
import { cn, getAssetSrc } from '@restworld/utils-common';
import { Button, Heading } from '@restworld/ui-ds-base';

export interface ModalMessageProps {
  title: string;
  subTitle?: string;
  onCloseCallback?: () => void;
  closeButtonTitle?: string;
  redirectBtnTitle?: string;
  onRedirectCallback?: () => void;
  iconSrc?: string | ReactNode;
  textAlign?: TextAlignType;
  children?: ReactNode;
}

type TextAlignType = 'center' | 'start';

export function ModalMessage({
  title,
  subTitle,
  closeButtonTitle,
  onCloseCallback,
  redirectBtnTitle,
  onRedirectCallback,
  iconSrc = getAssetSrc('/utils-assets/green-check-mark.svg'),
  textAlign = 'center',
  children,
}: ModalMessageProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 items-center pb-4 w-full',
        textAlign === 'center' ? 'text-center' : 'text-start'
      )}
    >
      {!!iconSrc && typeof iconSrc === 'string' ? <img src={iconSrc} className="h-8 w-8 mx-auto" alt="" /> : iconSrc}
      <div className="flex gap-14 flex-col">
        <div className="flex flex-col gap-4">
          <Heading size={1} weight="bold" align={textAlign === 'center' ? 'center' : 'left'}>
            {title}
          </Heading>
          {!!subTitle && (
            <Heading
              size={5}
              weight="normal"
              color="muted-foreground"
              align={textAlign === 'center' ? 'center' : 'left'}
            >
              {subTitle}
            </Heading>
          )}
        </div>
        {children}
        {Boolean(redirectBtnTitle || closeButtonTitle) && (
          <div className="flex flex-col gap-4 w-full items-center">
            {!!redirectBtnTitle && (
              <Button
                variant="primary"
                onClick={(e) => {
                  e?.preventDefault();
                  e?.stopPropagation();
                  !!onRedirectCallback && onRedirectCallback();
                }}
                className="w-full"
              >
                {redirectBtnTitle}
              </Button>
            )}
            {!!closeButtonTitle && (
              <Button variant="secondary-neutral" onClick={onCloseCallback} className="w-full">
                {closeButtonTitle}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ModalMessage;
